import { useTranslation } from "react-i18next";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import { MainContentWrapper, TableWrapper } from "../../../components/common/Common.styles";
import { Box } from "@mui/material";
import { CircularIndeterminate } from "../../../components/common/CircularIndeterminate";
import { useProcessingRequest } from "../../../store/selectors/tableManagementSelector";
import { useServerSidePagination } from "../../../hooks/PaginationHooks";
import { AnalysisFileType } from "../../../types/analysisFileTypes";
import AnalysisFileTableHeader from "../../superAdminArea/AnalysisFiles/AnalysisFileTableHeader";
import AnalysisFileTableRow from "../../superAdminArea/AnalysisFiles/AnalysisFileTableRow";
import { companyBillingsApi } from "../../../api/companyBillingsApi";
import { ServerSidePagination } from "../../../components/common/table/ServerSidePagination";


interface Props {
    fileType: AnalysisFileType;
    title: string;
}

export default function GenericAnalysisFilesPage(props: Props) {
    const { t } = useTranslation();

    const processingRequest = useProcessingRequest()
    const paginatedData = useServerSidePagination(
        async (paginationParameters) => {
            const res = await companyBillingsApi.getAnalysisFilesByFileType(
                paginationParameters,
                props.fileType
            );
            return res?.getResultOrNull();
        },
        [],
        "desc",
        "creationTimestamp"
    )

    return (<>
        <PageTitle title={t(props.title)} />

        <MainContentWrapper>
            <TableWrapper
                minWidth="1000px"
                columnsTemplate="1fr 1fr 0.5fr"
            >
                <AnalysisFileTableHeader
                    paginatedData={paginatedData}
                    showCompanyName={false} />

                <Box sx={{ display: "contents" }}>
                    {paginatedData.items.map((item) =>
                        <AnalysisFileTableRow
                            row={item}
                            showCompanyName={false}
                        />)
                    }
                </Box>
            </TableWrapper>
            <ServerSidePagination paginatedData={paginatedData} />
        </MainContentWrapper>

        <CircularIndeterminate processingRequest={processingRequest} />
    </>);
}